import React from 'react';

interface Props {
  src: string;
  alt: string;
  onClose: () => void;
}

export function ImageModal({ src, alt, onClose }: Props) {
  return (
    <div className="modal" onClick={onClose}>
      <img
        src={src}
        alt={alt}
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
